import { useMutation } from '@tanstack/react-query';
import api from '../../http';
import { getApiErrorMessage, toApiError } from '../utils';

export interface SyncReceiptUrlResponse {
	receiptUrl: string | null;
}

export const useSyncReceiptUrl = () => {
	return useMutation({
		mutationFn: async () => {
			try {
				return (await api.post<SyncReceiptUrlResponse>('/user/receipt-url/sync')).data;
			} catch (error) {
				throw toApiError(error, 'Erro ao buscar o comprovante');
			}
		},
		onError: (error) =>
			console.error('Erro ao buscar o comprovante:', getApiErrorMessage(error, 'Erro ao buscar o comprovante')),
	});
};
